import {actions} from '../slices/authSlice';
import {take, put, call, all} from 'redux-saga/effects';
import {eventChannel} from 'redux-saga';
import {firebase} from 'utils/firebase';
import NetworkHandler from 'utils/network';
import config from 'config';
import Auth from 'utils/auth';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';


function authStageListener() {
    return eventChannel(emitter => {
        const listener = firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                emitter(user);
            }
        });

        return listener;
    });
}

function idTokenListener() {
    return eventChannel(emitter => {
        const listener = firebase.auth().onIdTokenChanged((user) => {
            if (user) {
                emitter(user);
            }
        });

        return listener;
    });
}

function formatPhoneNumber(phoneNumber, globalize = true) {
    if (globalize) {
        if (phoneNumber[0] === '0') {
            return `+84${phoneNumber.slice(1)}`;
        } 
    
        return `+84${phoneNumber}`;
    } else {
        if (phoneNumber[0] !== '0') {
            return `0${phoneNumber}`;
        }
    
        return phoneNumber;
    }
    
}

function* loadUser() {
    try {
        const user = Auth.getUser();

        if (!user) {
            throw null;
        }


        if (!user || !user.phone_number || !user.fbAppId || user.fbAppId !== config.FIREBASE_APP_ID) {
            throw new Error('Vui lòng đăng nhập lại');
        }

        // Nếu có user thì user đã login, chuyển vào màn hình trong sau đó chờ firebase load token user
        yield put({type: actions.load_user_succeed.type, payload: user});

        const listener = yield call(authStageListener);
        const firebaseUser = yield take(listener);
        
        if (firebaseUser) {
            yield put({type: actions.login_firebase_succeed.type});
        }
    } catch (error) {
        yield firebase.auth().signOut();
        yield Auth.logout();
        yield put({type: actions.load_user_failed.type, payload: error});
    }
}

function* doPasswordLogin(rawPhoneNumber, password) {
    const phoneNumber = formatPhoneNumber(rawPhoneNumber, false);
    const res = yield NetworkHandler.post(`${config.getUrl('login_password',1)}`, 
        {
            grant_type: 'PASSWORD',
            username: phoneNumber, 
            password,
        }, null, true);

    yield firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(() => {
        return firebase.auth().signInWithCustomToken(res.data.customToken);
    });

    const user = yield getUserInfo();
  
    user.fbAppId = config.FIREBASE_APP_ID;

    Auth.setAuth(user);

    return {user};
}

function* loginWithPassword ({phoneNumber: rawPhoneNumber, password}) {
    try {
        const result = yield call(doPasswordLogin, rawPhoneNumber, password);
        yield put({type: actions.login_with_password_succeed.type, payload: result});
    } catch (error) {
        yield put({type: actions.login_with_password_failed.type, payload: error});
    }
}

function* logout() {
    yield firebase.auth().signOut();
    yield Auth.logout();
    yield put({type: actions.logout_succeed.type, payload: {}});
}

const getUserInfo =  async () => {
    const response = await NetworkHandler.get(`${config.getUrl('bus_staff')}/me`);
    return {
        ...response.data
    };
};

function* changePassword({oldPassword, newPassword}) {
    try {
        const user = yield getUserInfo();
        const res = yield NetworkHandler.put(
            `${config.getUrl('reset_password',1)}/${user.user_id}/password`, 
            {new_password:newPassword, old_password:oldPassword}, null, true); 
        if (res.message !== 'OK')
        {throw new Error(res.message);}
        yield put({type: actions.change_password_succeed.type, payload: res});
        NotificationHandler.notifySuccess('Thay đổi mật khẩu thành công!');
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.change_password_failed.type, payload:error});
    }
}



function* sendSMSCode({phoneNumber: rawPhoneNumber}) {
    try {
        const phoneNumber = formatPhoneNumber(rawPhoneNumber);
        const res = yield NetworkHandler.post(`${config.getUrl('get_sms_code',1)}`, 
            {
                phoneNumber,
                deviceId: 'admin'
            }, null, true);
        yield put({type: actions.send_sms_code_succeed.type, payload: res.data});
    } catch (error) {
        yield put({type: actions.send_sms_code_failed.type, payload:error});
    }
}
function* resetPassword(data) {
    try {
        const cToken = yield NetworkHandler.post(`${config.getUrl('verify_sms_code',1)}`, data, null, true);
        yield firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(() => {
            return firebase.auth().signInWithCustomToken(cToken.data.customToken);
        });
        const user = yield getUserInfo();
        user.fbAppId = config.FIREBASE_APP_ID;
        const phoneNumber = formatPhoneNumber(data.phoneNumber, false);
        yield NetworkHandler.post(
            `${config.getUrl('reset_password',1)}/${user.user_id}/reset-password`, 
            {username: phoneNumber}, null, true);
        yield put({type: actions.reset_password_succeed.type, payload: null});
    } catch (error) {
        yield put({type: actions.reset_password_failed.type, payload:error});
    }
}

function* updateUser(data) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_staff')}/me/current-company`, {
            ...data
        });
        Auth.setAuth({ ...response.data, fbAppId: config.FIREBASE_APP_ID });
        yield put({ type: actions.update_user_succeed.type, payload: { ...response.data } });
    } catch (error) {
        yield put({ type: actions.update_user_failed.type, payload: error });
    }
}





function* watchAuth() {
    while (true) {
        const loginActions = yield take([
            actions.send_sms_code.type, 
            actions.load_user.type, 
            actions.logout.type, 
            actions.login_with_password.type,
            actions.reset_password.type,
            actions.change_password.type,
            actions.update_user.type, 
        ]);
     
        switch (loginActions.type) {
        case actions.change_password.type:
            yield call(changePassword, loginActions.payload);
            break;
        case actions.reset_password.type:
            yield call(resetPassword, loginActions.payload);
            break;
        case actions.send_sms_code.type:
            yield call(sendSMSCode, loginActions.payload);
            break;
        case actions.load_user.type:
            yield call(loadUser, loginActions.payload);
            break;
        case actions.update_user.type:
            yield call(updateUser, loginActions.payload);
            break;
        case  actions.logout.type:
            yield call(logout);
            break;
        case actions.login_with_password.type:
            yield call(loginWithPassword, loginActions.payload);
            break;
        default: break;
        }
    }
}

function* watchUserIdToken() {
    const listener = yield call(idTokenListener);
    while (true) {
        const firebaseUser = yield take(listener);
        const idToken = yield firebaseUser.getIdToken();

        if (idToken) {
            yield put({type: actions.id_token_changed.type, payload: idToken});
        }
    }
}

export default function* watchAll() {
    yield all([
        watchAuth(),
        watchUserIdToken()
    ]);
}